import React from 'react';
import PropTypes from 'prop-types';

const parseError = (metaErrors) => {
  if (metaErrors && typeof metaErrors === 'string') {
    return [{ errorMessage: metaErrors }];
  }
  if (Array.isArray(metaErrors) && metaErrors.length > 0) {
    return metaErrors;
  }
  return metaErrors ? [metaErrors] : [];
};

const asReduxFormField = (Component) => {
  const WrappedComponent = ({
    meta,
    error = null,
    required = false,
    label,
    hideError = false,
    input: { value, onChange },
    ...props
  }) => {
    const isErrorDisplayed = !hideError && !!meta.error && (meta.touched || meta.submitFailed);

    return (
      <Component
        isRequired={required}
        label={label}
        error={isErrorDisplayed ? error || parseError(meta.error) : ''}
        value={value}
        onChange={onChange}
        {...props}
      />
    );
  };

  WrappedComponent.propTypes = {
    meta: PropTypes.object.isRequired,
    error: PropTypes.object,
    required: PropTypes.bool,
    hideError: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]).isRequired,
    input: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.bool]),
      onChange: PropTypes.func.isRequired,
    }).isRequired,
  };

  return WrappedComponent;
};

export default asReduxFormField;
